<template>
  <section class="withdraw">
    <div class="withdraw-block">
      <div class="withdraw-item">
        <div class="withdraw-main-label">提现金额</div>
        <div class="withdraw-main-unit">¥</div>
        <input
          type="number"
          class="withdraw-main-input"
          placeholder="请输入提现金额"
          v-model.number="amount"
        />
      </div>
      <div class="withdraw-tip">
        <span>可用金额：¥{{available.toFixed(2)}}（</span>
        <span class="withdraw-tip-red">最低提现20元起～</span>
        <span>）</span>
      </div>
    </div>
    <div class="withdraw-block">
      <div class="withdraw-item">
        <div class="withdraw-item-label">预计税费</div>
        <div class="withdraw-item-content">¥{{showTax.toFixed(2)}}</div>
      </div>
      <div class="withdraw-item">
        <div class="withdraw-item-label">预计到手金额</div>
        <div class="withdraw-item-content">¥{{showAmount.toFixed(2)}}</div>
      </div>
      <div class="withdraw-item">
        <div class="withdraw-item-label">提现时间</div>
        <div class="withdraw-item-content-red">每月1日~25日</div>
      </div>
    </div>
    <div class="withdraw-warning">注：根据国家规定，每人每月提现超过800以上，应当按照阶梯进入税收，系统将会根据填写的提现金额计算出对应的预计税收价格。</div>
    <div class="withdraw-block">
      <div class="withdraw-item">
        <div class="withdraw-item-label">本月累计已提现</div>
        <div class="withdraw-item-content-blue">¥{{history.toFixed(2)}}</div>
      </div>
    </div>
    <div class="withdraw-bottom">
      <UIButton height="82" width="650" @click="apply" :type="this.provide ? 'blue': 'normal'">申请提现</UIButton>
    </div>
  </section>
</template>

<script>

import api from '@edu-fe/api'
import UIButton from '../components/UI/Button'

import '../style/withdraw.scss'

const request = {
  // 用户身份及本月已提金额
  withdrawInfo: api.create('/promote/member'),

  // 可用金额
  withdrawTotal: api.create('/money/total'),

  // 计算税额
  withdrawTax: api.create('/promote/calculate/tax'),

  // 提现
  withdraw: api.create('/promote/record/save', {
    method: 'post'
  })
}

export default {
  data () {
    return {
      amount: 0,
      showTax: 0,
      showAmount: 0,
      loading: false,
      available: 0,
      history: 1
    }
  },

  computed: {
    provide () {
      return this.$route.query.provide === 'ciba'
    }
  },
  watch: {
    amount (value) {
      this.computeTax(value)
    }
  },

  methods: {
    async computeTax (money) {
      clearTimeout(this._computeTaxTimer)
      this._computeTaxTimer = setTimeout(async () => {
        const { data } = await request.withdrawTax({ money })
        this.showTax = data.tax
        this.showAmount = data.money
      }, 500)
    },

    async apply () {
      if (this.loading) {
        return
      }

      if (!this.amount) {
        return this.$toast.show({
          message: '请输入提现金额'
        })
      }

      this.loading = true

      setTimeout(async () => {
        const { code } = await request.withdraw({
          money: this.showAmount,
          taxes: this.showTax
        })
        this.loading = false

        switch (code) {
          case 1:
            setTimeout(() => {
              this.$router.replace({
                path: '/money',
                query: {
                  popupType: 4,
                  from: this.$route.query.from || '',
                  provide: this.$route.query.provide || ''
                }
              })
            }, 500)
            break
          case 1033:
            this.$toast.show({
              message: `已有提现记录`
            })
            break
          case 1014:
            this.$toast.show({
              message: `手机号已绑定`
            })
            break
          case 1013:
            this.$toast.show({
              message: `验证码不正确`
            })
            break
          case 1004:
            this.$toast.show({
              message: `最低提现1元`
            })
            break
          case 1035:
            this.$toast.show({
              message: `余额不足`
            })
            break
          case 1036:
            this.$toast.show({
              message: `本月提现金额不得超过800`
            })
            break
          default:
            this.$toast.show({
              message: `提现失败 (code: ${code})`
            })
        }
      }, 500)
    },

    async getInfo () {
      const { data, code } = await request.withdrawInfo()
      if (code === 1) {
        this.history = data.currentMonthMoney
      }
    },

    async getTotal () {
      const { data, code } = await request.withdrawTotal()
      if (code === 1) {
        this.available = data.balance
      }
    }
  },

  async created () {
    this.getInfo()
    this.getTotal()
  },

  components: {
    UIButton
  }
}

</script>
